import { client } from '~shared/api';

import { RoundingErrorDto, RoundingErrorDtoScheme } from '../dto';

export async function fetchRounding() {
	const data = await client.get(`/rounding`);
	return RoundingErrorDtoScheme.parse(data);
}

export async function updateRounding(data: RoundingErrorDto) {
	return client.put('/rounding', data);
}
